module.exports = __webpack_public_path__ + "media/packs/images/flags/KP-6d3fc20a154109a290d158bc86c8eed2.svg";